import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import AddBoxIcon from '@mui/icons-material/AddBox'

import styles from './FileList.module.css'
import { saveFiles, defaultFiles } from '../lib/esp'

// Fichiers disponibles côté projet
const availableFiles = [
  { name: 'UC-1-Magique-Basic.bin', path: '/bin/UC-1-Magique-Basic.bin', size: 102400 },
  { name: 'UC-1-Magique-PIR.bin', path: '/bin/UC-1-Magique-PIR.bin' , size: 204800 },
]

const FileList = ({ uploads, setUploads, chipName }) => {
  const fileInputRef = useRef()

useEffect(() => {
  if (uploads.length === 0) {
    setUploads([{ offset: '10000', fileName: '', obj: null }])
  }
}, [])

  const handleSelectPredefined = async (e) => {
  const fileName = e.target.value
  const fileMeta = availableFiles.find(f => f.name === fileName)

  try {
    const response = await fetch(fileMeta.path)
    const blob = await response.blob()

    const realFile = new File([blob], fileMeta.name, {
      type: "application/octet-stream"
    })

    const newUpload = {
      offset: uploads[0]?.offset || '0',
      fileName: fileMeta.name,
      obj: realFile
    }

    saveFiles([newUpload])
    setUploads([newUpload])
  } catch (error) {
    console.error("Failed to load predefined firmware:", error)
  }
}

  const handleFileUpload = (event) => {
    const file = event.target.files[0]
    if (!file) return

    const newUpload = {
      offset: uploads[0]?.offset || '0',
      fileName: file.name,
      obj: file
    }

    saveFiles([newUpload])
    setUploads([newUpload])
  }

  const handleAddClick = () => {
    fileInputRef.current.click()
  }

  const setOffset = (newOffset) => {
    const updated = {
      ...uploads[0],
      offset: newOffset
    }

    saveFiles([updated])
    setUploads([updated])
  }

  const onlyHex = (e) => {
    const re = /[0-9a-fA-F]+/g
    if (!re.test(e.key)) e.preventDefault()
  }

  const reset = () => {
    const newUploads = defaultFiles(chipName)
    saveFiles(newUploads)
    setUploads(newUploads)
  }

  const selectedFileName = uploads[0]?.fileName || ''

  return (
    <Box textAlign='center' className={styles.box}>
      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={6} md={5}>
          <Box align="center" sx={{ mb: 2 }}>
            <img src="/logo.png" alt="FOULE.ING" style={{ width: '100px', height: 'auto' }} />
          </Box>

          <Box align="center" sx={{ mb: 2 }}>
            <Typography
              sx={{
                fontSize: '1rem',
                fontFamily: 'DIN Alternate',
                fontWeight: 'bold',
                color: '#000000',
                textAlign: 'center',
              }}
            >
              Choose or upload a firmware to flash.
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item xs={2}>
          <TextField
            label='0x'
            variant='outlined'
            size='small'
            value={uploads[0]?.offset || '10000'}
            onKeyDown={onlyHex}
            onChange={(e) => setOffset(e.target.value)}
          />
        </Grid>

        <Grid item xs={6}>
          <Select
            fullWidth
            size='small'
            displayEmpty
            value={selectedFileName}
            onChange={handleSelectPredefined}
            renderValue={(selected) => selected || "Select a firmware"}
          >
            {availableFiles.map((file, idx) => (
              <MenuItem key={idx} value={file.name}>
                {file.name} ({(file.size / 1024).toFixed(1)} KB)
              </MenuItem>
            ))}
          </Select>
        </Grid>

        <Grid item xs={4}>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleAddClick}
            endIcon={<AddBoxIcon />}
          >
            Upload from PC
          </Button>
          <input
            type="file"
            ref={fileInputRef}
            accept=".bin"
            style={{ display: 'none' }}
            onChange={handleFileUpload}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
        <Grid item>
          <Button
            color='error'
            size='large'
            onClick={reset}
            endIcon={<RestartAltIcon />}
          >
            Reset
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

FileList.propTypes = {
  uploads: PropTypes.array,
  setUploads: PropTypes.func,
  chipName: PropTypes.string,
}

export default FileList
